export default __webpack_public_path__ + "static/realWorldImg5-f46fba9c987660edcae682534d9d899d.webp";